import React, { PureComponent } from 'react';
import { createSelector } from 'reselect';
import NavigationError from 'app/constants/NavigationError';
import { useSyncNavigator } from 'app/containers/call/SyncNavigatorContext';
import { History } from 'app/services/history';
import { T, tFunctionType } from 'app/components/localization';
import { useHistory } from 'app/components/router/History';
import CallErrorMessage from 'app/components/call/CallErrors/CallErrorMessage';

interface INavigationError { name: string; message: string; url: string; }

interface INavigationErrorProps {
  error?: INavigationError;
  history: History;
}

class NavigationErrorMessage extends PureComponent<INavigationErrorProps> {
  private readonly getMessage = createSelector(
    (t: tFunctionType, error?: INavigationError) => t,
    (t: tFunctionType, error?: INavigationError) => error && error.name,
    (t: tFunctionType, error?: INavigationError) => error && error.url,
    (t: tFunctionType, error?: INavigationError) => error && error.message,
    (t: tFunctionType, name?: string, url?: string, message?: string) =>
      name === NavigationError.NAME
      ? t('rtc.errors.navigation-overflow', { url })
      : message,
  );

  public render() {
    const {
      navigateAgain,
      getMessage,
      props: { error },
    } = this;

    return (
      <T>{t => {
        const message = getMessage(t, error);

        return (
          !message ? null :
          <CallErrorMessage buttonAction={navigateAgain} buttonLabel={t('rtc.try-again')}>
            {message}
          </CallErrorMessage>
        );
      }}</T>
    );
  }

  private readonly navigateAgain = () => {
    const { error, history } = this.props;
    if (error && error.url) {
      history.push(error.url);
    }
  };
}

const NavigationErrorMessageInjectDependencies = () => {
  const history = useHistory();
  const { error } = useSyncNavigator();

  return <NavigationErrorMessage error={error} history={history} />;
};

export default NavigationErrorMessageInjectDependencies;
